import { ExternalButton } from 'app/ui_v2/components/external-button/ExternalButton';

import { Box, Button, SxProps, Theme, useTheme } from '@mui/material';

import { getInspectionExternalLink } from '../../config';

export interface ReportIdProps {
  id: string;
}

const getStyles = (theme: Theme): { [key: string]: SxProps } => {
  return {
    idCell: {
      fontSize: '1.5rem',
      color: theme.palette.info.light,
      fontWeight: 600,
    },
    button: {
      padding: 0,
      minWidth: '1px',
      color: theme.palette.info.light,
      textDecoration: 'none',
      '&:hover': {
        textDecoration: 'underline',
      },
    },
  };
};

export default function ReportId(props: ReportIdProps) {
  const { id } = props;

  const theme = useTheme();
  const styles = getStyles(theme);

  return (
    <Button component={ExternalButton} to={getInspectionExternalLink(id)} sx={styles.button}>
      <Box display="flex" alignItems="center" justifyContent={'center'} flexDirection={'column'} color="#1a2c4e">
        <Box ml={0} sx={styles.idCell}>
          {id}
        </Box>
      </Box>
    </Button>
  );
}
